import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InAppService, ServerComService } from '../../../../../../shared';

@Component({
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html',
  styleUrls: ['./email-verify.component.css'],
})
export class EmailVerifyComponent implements OnInit, OnDestroy {
  userEmail: string;
  c1: number;
  c2: number;
  c3: number;
  c4: number;
  verCode: string;
  submitting = false;
  codeSent = false;
  currentToken: string;
  showResend = false;
  resendTimer = 60;
  mode = 'enterCode';

  constructor(
    private inAppService: InAppService,
    private serverCom: ServerComService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.userEmail = this.inAppService.storedSupplierInfo?.email || '';
    this.inAppService.notLoggedIn = false;
    this.inAppService.hideSignOptions.emit(true);
    this.requestCode();
  }

  ngOnDestroy() {
    this.inAppService.hideSignOptions.emit(false);
  }

  requestCode() {
    this.submitting = true;
    this.showResend = false;
    this.serverCom.sendEmailOtp().subscribe(
      (data) => {
        this.submitting = false;
        this.codeSent = true;
        this.currentToken = data.userToken;
        this.startResendTimer();
      },
      () => {
        this.submitting = false;
        this.inAppService.showStatusMessage.next({
          text: 'Could not send verification email. Please refresh and try again.',
          location: 'logsign',
          type: 'danger',
        });
      }
    );
  }

  startResendTimer() {
    this.resendTimer = 60;
    const interval = setInterval(() => {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        clearInterval(interval);
        this.showResend = true;
      }
    }, 1000);
  }

  submitCode() {
    this.submitting = true;
    this.serverCom.validateEmailOtp(this.verCode, this.currentToken).subscribe(
      () => {
        this.submitting = false;
        this.inAppService.phoneVerfied = true;
        this.inAppService.updatePhoneVerified.emit(true);
        this.router.navigate(['admin/submitted-items']);
        setTimeout(() => {
          this.inAppService.showStatusMessage.next({
            text: 'Email verified successfully.',
            location: 'addItem',
            type: 'success',
          });
        }, 1000);
      },
      () => {
        this.submitting = false;
        this.clearInputs();
        this.inAppService.showStatusMessage.next({
          text: 'The code you entered is incorrect. Please try again.',
          location: 'logsign',
          type: 'danger',
        });
      }
    );
  }

  clearInputs() {
    for (let i = 0; i < 4; i++) {
      const input = document.getElementById('c' + i) as HTMLInputElement;
      if (input) input.value = '';
    }
    const first = document.getElementById('c0') as HTMLInputElement;
    if (first) first.focus();
  }

  goToNextInput(index: number, event: Event) {
    const key = event['key'];
    const pressedValid = key !== 'Backspace' && key !== 'ArrowRight' && key !== 'ArrowLeft'
      && key !== 'ArrowUp' && key !== 'ArrowDown' && key !== 'Tab';

    if (index < 3 && pressedValid) {
      const next = document.getElementById('c' + (index + 1)) as HTMLInputElement;
      if (next) next.focus();
    } else if (pressedValid) {
      this.verCode = '' + this.c1 + this.c2 + this.c3 + this.c4;
    } else if (key === 'Backspace') {
      const cur = document.getElementById('c' + index) as HTMLInputElement;
      if (cur && cur.value.length === 0 && index > 0) {
        const prev = document.getElementById('c' + (index - 1)) as HTMLInputElement;
        if (prev) { prev.value = ''; prev.focus(); }
      }
    }
  }

  onSubmit(form: NgForm) {
    if (form.valid && this.codeSent) {
      this.verCode = '' + this.c1 + this.c2 + this.c3 + this.c4;
      this.submitCode();
    }
  }
}
